module.exports = __webpack_public_path__ + "img/sCandyBona_193x205.3d60eafa.png";